import { type ReactElement } from 'react'
import { type UnsavedQuiz } from '@terros/common'
import { type UseFormReturnType } from '@mantine/form'
import { Box, Group, Stack, Text } from '@mantine/core'
import { TSection, UserMultiInlineSelect, UserInfo } from '@components'

type QuizEditorsSectionProps = {
  form: UseFormReturnType<UnsavedQuiz>
}

export const QuizEditorsSection = ({ form }: QuizEditorsSectionProps): ReactElement => {
  return (
    <TSection title='Quiz Editors' heading={{ title: 'Quiz Editors' }}>
      <Stack gap='md'>
        <Box>
          <Text fz='sm' fw={500} c='dimmed' mb={4}>
            Owner
          </Text>
          <Group gap='xs'>
            <UserInfo 
              userId={form.values.ownerId} 
              size='md' 
              linked
            />
            <Text fz='xs' c='dimmed'>(Cannot be changed)</Text>
          </Group>
        </Box>

        <Box>
          <UserMultiInlineSelect
            value={form.values.editors || []}
            onChange={(value) => form.setFieldValue('editors', value)}
            label='Additional Editors'
            description='These users can modify all aspects of this quiz including questions, settings, and assignees'
            placeholder='Search for users to add as editors...'
          />
        </Box>
      </Stack>
    </TSection>
  )
}